import React, { Component } from 'react';
import { makeTimeString, isEmpty } from '../../../Common/Common';
import Editbox from '../../../Part_Sample/Editbox';
import Top_Bar from '../../../Part_Sample/Top_Bar';

import Command_Power from '../../../Commands/Command_Power_On_Off';
import Command_Setpoint from '../../../Commands/Command_Setpoint';
import Command_Hum_Setpoint from '../../../Commands/Command_Hum_Setpoint';
import Command_Fanstep from '../../../Commands/Command_Fanstep';
import Command_Mode from '../../../Commands/Command_Mode';
import Command_Level from '../../../Commands/Command_Level';

import Command_Off_Timer from '../../../Commands/Schedule_Commands/Command_Off_Timer';
import Command_Setback_Cool from '../../../Commands/Schedule_Commands/Command_Setback_Cool';
import Command_Setback_Heat from '../../../Commands/Schedule_Commands/Command_Setback_Heat';
import Command_Execute_Scene from '../../../Commands/Schedule_Commands/Command_Execute_Scene';
import Command_Interlock_Schedule from '../../../Commands/Schedule_Commands/Command_Interlock_Schedule';
import Command_Notification from '../../../Commands/Schedule_Commands/Command_Notification';
import Command_Lock from '../../../Commands/Command_Lock';
import Command_Shutter from '../../../Commands/Command_Shutter';
import Command_RGB_Input from '../../../Commands/Command_RGB_Input';
import Command_RC_Proh_Op from '../../../Commands/Schedule_Commands/Command_RC_Proh_Op';
import Command_RC_Proh_Mode from '../../../Commands/Schedule_Commands/Command_RC_Proh_Mode';
import Command_RC_Proh_SP from '../../../Commands/Schedule_Commands/Command_RC_Proh_SP';
import Command_RC_Proh_Fanstep from '../../../Commands/Schedule_Commands/Command_RC_Proh_Fanstep';
import Command_VMode from '../../../Commands/Command_VMode';
import Command_VAmount from '../../../Commands/Command_VAmount';
import Command_Freshup from '../../../Commands/Command_Freshup';

export default class Add_Edit_Action extends Component {
	constructor(props) {
		super(props);

		this.pattern = JSON.parse(JSON.stringify(this.props.param.pattern))
		let pattern_name = '';
		let action_details = {};
		if (this.props.param.time != null) {
			action_details = this.pattern.action[this.props.param.time];
		}

		let hour = '00';
		let min = '00';
		if (this.props.param.time != null) {
			hour = this.props.param.time.substring(0, 2);
			min = this.props.param.time.substring(3, 5);
		}

		this.state = {
			pattern_name: pattern_name,
			action_details: action_details,
			hour: hour,
			min: min,
			tab: 'general',
		}
	}

	handlePrevious = () => {
		this.props.content_handler('Add_Edit_Pattern', this.props.param);
	}

	// handle change Commands
	handleChangeScheduleTimerHour = (val) => {
		let time = val + ':' + this.state.min;
		if (time != this.props.param.time && this.pattern.action[time] != null) {
			window.app.showToast(this.props.receiver.getString('action_exists'), 3000);
		}

		this.setState({ hour: val })
	}

	handleChangeScheduleTimerMin = (val) => {
		let time = this.state.hour + ':' + val;
		if (time != this.props.param.time && this.pattern.action[time] != null) {
			window.app.showToast(this.props.receiver.getString('action_exists'), 3000);
		}

		this.setState({ min: val })
	}

	handleShowCommands = (tab) => {
		this.setState({ tab: tab })
	}

	handleChangeStat = (stat) => {
		let action_details = this.state.action_details;
		if (stat != null) {
			action_details.stat = stat
		} else if (action_details.stat != null) {
			delete action_details.stat
		}

		this.setState({ action_details: action_details });
	}

	handleChangeSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sp = val
		} else if (action_details.sp != null) {
			delete action_details.sp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeHumSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.hum_sp = val
		} else if (action_details.hum_sp != null) {
			delete action_details.hum_sp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeFanstep = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.fanstep = val
		} else if (action_details.fanstep != null) {
			delete action_details.fanstep
		}

		this.setState({ action_details: action_details });
	}

	handleChangeMode = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.mode = val
		} else if (action_details.mode != null) {
			delete action_details.mode
		}

		this.setState({ action_details: action_details });
	}

	handleChangeOffTimer = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.off_timer = val
		} else if (action_details.off_timer != null) {
			delete action_details.off_timer
		}

		this.setState({ action_details: action_details });
	}

	handleChangeCoolSetback = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sb_csp = val
		} else if (action_details.sb_csp != null) {
			delete action_details.sb_csp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeHeatSetback = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sb_hsp = val
		} else if (action_details.sb_hsp != null) {
			delete action_details.sb_hsp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeShutterStatus = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.shutter = val
		} else if (action_details.shutter != null) {
			delete action_details.shutter
		}

		this.setState({ action_details: action_details });
	}

	handleChangeLockStatus = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.lock = val
		} else if (action_details.lock != null) {
			delete action_details.lock
		}

		this.setState({ action_details: action_details });
	}

	handleChangeRGB = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			val = val + "FF"; //add in W parameter
			let hex_code = val.substring(1); //remove #
			let rgbw_code = parseInt(hex_code, 16); //Convert hexadecimal to decimal
			action_details.rgbw = rgbw_code
		} else if (action_details.rgbw != null) {
			delete action_details.rgbw
		}

		this.setState({ action_details: action_details });
	}

	handleChangeSceneExec = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.exec = val
		} else if (action_details.exec != null) {
			delete action_details.exec
		}

		this.setState({ action_details: action_details });
	}

	handleChangeInterlockSchedule = (val) => {
		if (val == 'true') {
			val = true;
		} else if (val == 'false') {
			val = false;
		}

		let action_details = this.state.action_details;
		if (val != null) {
			action_details.enable = val
		} else if (action_details.enable != null) {
			delete action_details.enable
		}

		this.setState({ action_details: action_details });
	}

	handleChangeNotification = (val) => {
		if (val == 'true') {
			val = true;
		} else if (val == 'false') {
			val = false;
		}

		let action_details = this.state.action_details;
		if (val != null) {
			action_details.notify = val
		} else if (action_details.notify != null) {
			delete action_details.notify
		}

		this.setState({ action_details: action_details });
	}

	handleChangeAV = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.av = val
		} else if (action_details.av != null) {
			delete action_details.av
		}

		this.setState({ action_details: action_details });
	}

	handleRegister = () => {
		if (isEmpty(this.state.action_details)) {
			window.app.showToast(this.props.receiver.getString('no_action'), 3000);
			return;
		}

		let time = this.state.hour + ':' + this.state.min;
		if (time != this.props.param.time && this.pattern.action[time] != null) {
			window.app.showToast(this.props.receiver.getString('same_time'), 3000);
			return;
		}

		// Check that action is not null. If new pattern usually action is null
		if (this.pattern.action == null) this.pattern.action = {};
		// Check that previously no 
		if (this.props.param.time != null) {
			delete this.pattern.action[this.props.param.time];
		}

		this.pattern.action[time] = JSON.parse(JSON.stringify(this.state.action_details));
		let param = { op_type: this.props.param.op_type, program_id: this.props.param.program_id, pattern: this.pattern, pattern_id: this.props.param.pattern_id, schedule: this.props.param.schedule, program: this.props.param.program, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups };
		if (this.props.param.original_from != null) param.original_from = this.props.param.original_from;
		this.props.content_handler('Add_Edit_Pattern', param);
	}

	handleDelete = () => {
		delete this.pattern.action[this.props.param.time];
		let param = { op_type: this.props.param.op_type, program_id: this.props.param.program_id, pattern: this.pattern, pattern_id: this.props.param.pattern_id, schedule: this.props.param.schedule, program: this.props.param.program, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups };
		if (this.props.param.original_from != null) param.original_from = this.props.param.original_from;
		this.props.content_handler('Add_Edit_Pattern', param);
	}

	handleToggleRCProhOp = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rop_proh = val
		} else if (action_details.rop_proh != null) {
			delete action_details.rop_proh
		}

		this.setState({ action_details: action_details });
	}

	handleToggleRCProhMode = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rmode_proh = val
		} else if (action_details.rmode_proh != null) {
			delete action_details.rmode_proh
		}

		this.setState({ action_details: action_details });
	}

	handleToggleRCProhSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rsp_proh = val
		} else if (action_details.rsp_proh != null) {
			delete action_details.rsp_proh
		}

		this.setState({ action_details: action_details });
	}

	handleToggleRCProhFanstep = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rfan_proh = val
		} else if (action_details.rfan_proh != null) {
			delete action_details.rfan_proh
		}

		this.setState({ action_details: action_details });
	}

	handleChangeVMode = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.vmode = val
		} else if (action_details.vmode != null) {
			delete action_details.vmode
		}

		this.setState({ action_details: action_details });
	}

	handleChangeVAmount = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.vamount = val
		} else if (action_details.vamount != null) {
			delete action_details.vamount
		}

		this.setState({ action_details: action_details });
	}

	handleChangeFreshup = (freshup) => {
		let action_details = this.state.action_details;
		if (freshup != null) {
			action_details.freshup = freshup
		} else if (action_details.freshup != null) {
			delete action_details.freshup
		}

		this.setState({ action_details: action_details });
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let selectStyle = {
			marginRight: 10,
			height: 30,
			textAlign: 'center',
			border: 'none',
			background: 'none',
			borderBottom: '1px solid #0098de',
			outline: 'none',
			verticalAlign: 'top',
			cursor: 'pointer',
		}

		let hourRange = [];
		let minRange = [];

		for (let i = 0; i < 24; i++) {
			if (makeTimeString(i) == this.state.hour) {
				hourRange.push(<option value={makeTimeString(i)} selected>{makeTimeString(i)}</option>)
			} else {
				hourRange.push(<option value={makeTimeString(i)}>{makeTimeString(i)}</option>)
			}
		}

		for (let j = 0; j < 60; j++) {
			if (makeTimeString(j) == this.state.min) {
				minRange.push(<option value={makeTimeString(j)} selected>{makeTimeString(j)}</option>)
			} else {
				minRange.push(<option value={makeTimeString(j)}>{makeTimeString(j)}</option>)
			}
		}

		let dynamic_content = null;
		let action_details = this.state.action_details;

		//Controller Options Validation
		let available_functions = this.props.receiver.active_controller.available_functions;

		switch (this.state.tab) {
			case 'general':
				dynamic_content =
					<div>
						<Command_Power receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeStat={this.handleChangeStat} />
						<Command_Off_Timer receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeOffTimer={this.handleChangeOffTimer} />
						<Command_Notification receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeNotification={this.handleChangeNotification} />
					</div>
				break;
			case 'Ac':
				dynamic_content =
					<div style={{ height: this.props.height - 233, overflowY: 'auto' }}>
						<Command_Setpoint point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeSP={this.handleChangeSP} />
						<Command_Fanstep point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeFanstep={this.handleChangeFanstep} />
						<Command_Mode receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeMode={this.handleChangeMode} />
						<Command_Hum_Setpoint point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeHumSP={this.handleChangeHumSP} />
						<Command_Setback_Cool style={{ display: available_functions.setback ? 'block' : 'none' }} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeCoolSetback={this.handleChangeCoolSetback} />
						<Command_Setback_Heat style={{ display: available_functions.setback ? 'block' : 'none' }} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeHeatSetback={this.handleChangeHeatSetback} />
						<Command_RC_Proh_Op style={{ display: available_functions.rc_proh ? 'block' : 'none' }} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhOp={this.handleToggleRCProhOp} />
						<Command_RC_Proh_Mode style={{ display: available_functions.rc_proh ? 'block' : 'none' }} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhMode={this.handleToggleRCProhMode} />
						<Command_RC_Proh_SP style={{ display: available_functions.rc_proh ? 'block' : 'none' }} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhSP={this.handleToggleRCProhSP} />
						<Command_RC_Proh_Fanstep style={{ display: available_functions.rc_proh ? 'block' : 'none' }} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhFanstep={this.handleToggleRCProhFanstep} />
					</div>
				break;
			case 'Hrv':
				dynamic_content =
					<div>
						<Command_VMode receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeVMode={this.handleChangeVMode} />
						<Command_VAmount receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeVAmount={this.handleChangeVAmount} />
						<Command_Freshup receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeFreshup={this.handleChangeFreshup} />
						<Command_RC_Proh_Op style={{ display: available_functions.rc_proh ? 'block' : 'none' }} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhOp={this.handleToggleRCProhOp} />
					</div>
				break;
			case 'scenes':
				dynamic_content =
					<div>
						<Command_Execute_Scene receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeSceneExec={this.handleChangeSceneExec} />
					</div>
				break;
			case 'program':
				dynamic_content =
					<div>
						<Command_Interlock_Schedule receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeInterlockSchedule={this.handleChangeInterlockSchedule} />
					</div>
				break;
			case 'level':
				dynamic_content = <Command_Level receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeAV={this.handleChangeAV} />
				break;
			case 'lock':
				dynamic_content = <Command_Lock receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeLockStatus={this.handleChangeLockStatus} />
				break;
			case 'shutter':
				dynamic_content = <Command_Shutter receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeShutterStatus={this.handleChangeShutterStatus} />
				break;
			case 'rgbw':
				dynamic_content = <Command_RGB_Input receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeRGB={this.handleChangeRGB} />
				break;
			default:

		}

		let isDisplayAc = false;
		let isDisplayHrv = false;
		let isDisplayLevel = false;

		for (let point_id in window.app.state.point_list) {
			if(window.app.state.point_list[point_id].type == 'Ac') isDisplayAc = true;
			if(window.app.state.point_list[point_id].type == 'Dehumi') isDisplayAc = true;
			if(window.app.state.point_list[point_id].type == 'Hrv') isDisplayHrv = true;
			if(window.app.state.point_list[point_id].type == 'Level') isDisplayLevel = true;
			if(window.app.state.point_list[point_id].type == 'LevelSw') isDisplayLevel = true;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.time == null ? this.props.receiver.getString('add_action') : this.props.receiver.getString('edit_action')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 20 }}>
						<span className='subtitle' style={{ verticalAlign: 'top', display: 'inline-block' }}>Time: </span>
						<select id='Command_Schedule_Timer_Hour' defaultValue={this.state.hour} onChange={(event) => this.handleChangeScheduleTimerHour(event.target.value)} style={selectStyle}>
							{hourRange}
						</select>
						<span className='subtitle' style={{ verticalAlign: 'top', display: 'inline-block' }}>: </span>
						<select id='Command_Schedule_Timer_Min' defaultValue={this.state.min} onChange={(event) => this.handleChangeScheduleTimerMin(event.target.value)} style={selectStyle}>
							{minRange}
						</select>
					</div>
					<div style={{ whiteSpace: 'nowrap', overflow: 'auto', marginTop: 20 }}>
						<span id='general' style={{ cursor: 'pointer', display: 'inline-block', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'general' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'general' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('general')}>{this.props.receiver.getString('general')}</span>
						<span id='ac' style={{ cursor: 'pointer', display: isDisplayAc ? 'inline-block' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'Ac' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'Ac' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('Ac')}>{this.props.receiver.getString('ac')}</span>
						<span id='hrv' style={{ cursor: 'pointer', display: isDisplayHrv ? 'inline-block' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'Hrv' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'Hrv' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('Hrv')}>{this.props.receiver.getString('hrv')}</span>
						<span id='level' style={{ cursor: 'pointer', display: isDisplayLevel ? 'inline-block' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'level' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'level' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('level')}>{this.props.receiver.getString('level')}</span>
						{/* <span id='door_lock' style={{ cursor: 'pointer', display: 'inline-block', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'lock' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'lock' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('lock')}>{this.props.receiver.getString('lock')}</span> */}
						{/* <span id='shutter' style={{ cursor: 'pointer', display: 'inline-block', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'shutter' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'shutter' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('shutter')}>{this.props.receiver.getString('shutter')}</span> */}
						{/* <span id='rgbw' style={{ cursor: 'pointer', display: 'inline-block', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'rgbw' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'rgbw' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('rgbw')}>{this.props.receiver.getString('rgbw')}</span> */}
						<span id='scene' style={{ cursor: 'pointer', display: available_functions.scene ? 'inline-block' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'scenes' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'scenes' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('scenes')}>{this.props.receiver.getString('scene')}</span>
						<span id='program' style={{ cursor: 'pointer', display: available_functions.interlock || available_functions.schedule ? 'inline-block' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, padding: 20, textAlign: 'center', backgroundColor: this.state.tab == 'program' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'program' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('program')}>{this.props.receiver.getString('program')}</span>
					</div>

					{dynamic_content}
				</div>
			</div>
		)
	}
}